import { NullableRecord, mapValues } from '@dozuki/web-js/utils';
import { Stack, Text, Tooltip, Select } from '@chakra-ui/react';
import { ChangeEvent } from 'react';
import { useLocalization } from '~/framework';
import { Icon, B } from '~/ui-components';
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { Stage } from '../Stage';

type StageUseDatacaptureEditorProps = {
   stage: Stage;
   onChange: (newStageValues: Stage) => void;
};

export function StageUseDatacaptureEditor({ stage, onChange }: StageUseDatacaptureEditorProps) {
   const { _js } = useLocalization();

   const stageUseDatacaptureDescriptions: NullableRecord<number | null, string> = {
      null: _js('Select a view'),
      0: _js('Default guide view'),
      1: _js('Operator mode (full screen)'),
   };

   function handleChange(e: ChangeEvent<HTMLSelectElement>) {
      onChange({
         ...stage,
         use_datacapture: e.target.value === '1',
      });
   }

   return (
      <Stack direction="row" align="center">
         <Tooltip
            label={_js(
               'User will be directed to the default guide view or full-screen operator mode during the course'
            )}
         >
            <Text cursor="pointer">
               {_js('View options')}
               <Icon ml={1} type={faQuestionCircle} />
            </Text>
         </Tooltip>
         <Select
            flex={9}
            onChange={handleChange}
            value={stage.use_datacapture === null ? 'null' : Number(stage.use_datacapture)}
         >
            {mapValues(stageUseDatacaptureDescriptions, (description, stageUseDatacapture) => {
               const isDefaultOption = stageUseDatacapture == 'null';
               return (
                  <option
                     value={stageUseDatacapture}
                     key={stageUseDatacapture}
                     disabled={isDefaultOption}
                     style={{
                        color: isDefaultOption ? 'gray' : 'inherit',
                        backgroundColor: isDefaultOption ? '#f0f0f0' : 'inherit',
                        cursor: isDefaultOption ? 'not-allowed' : 'pointer',
                     }}
                  >
                     {description}
                  </option>
               );
            })}
         </Select>
      </Stack>
   );
}
